import { HStack, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { Flag } from 'lucide-react';
import { CONTENT_REPORT_REASONS } from '@/constants/contentReportReasons';
import { TContentReportReason } from '@/types/Content.types';

// Reporting asks for a reason rather than firing blind, so the moderation queue gets a
// usable signal instead of an undifferentiated "other".
const ReportMenu = ({ onReport }: { onReport: (reason: TContentReportReason) => void }) => (
  <Menu placement="top">
    <MenuButton
      as={HStack}
      aria-label="Report"
      justify="center"
      width="48px"
      height="48px"
      borderRadius="full"
      cursor="pointer"
      backgroundColor="white"
      color="text.mediumBlue"
      boxShadow="0px 4px 14px rgba(14, 0, 98, 0.10)"
      transition="all 0.15s ease"
      _hover={{ transform: 'translateY(-2px)', color: 'primary.500' }}
    >
      <Flag size={20} strokeWidth={2} />
    </MenuButton>
    <MenuList>
      {CONTENT_REPORT_REASONS.map(({ value, label }) => (
        <MenuItem key={value} onClick={() => onReport(value)}>
          {label}
        </MenuItem>
      ))}
    </MenuList>
  </Menu>
);

export default ReportMenu;
